import { createAction, props } from '@ngrx/store';
import { LoggedInUser } from '@ipensii/shared/domain-shared';

export class LoggedInUserActions {
  static readonly loadUser = createAction('[Shared - LoggedInUser] - Load User');
  static readonly loadUserSuccess = createAction(
    '[Shared - LoggedInUser] - Load User Success',
    props<{ user: LoggedInUser }>()
  );
  static readonly loadUserError = createAction('[Shared - LoggedInUser] - Load User Error', props<{ error: Error }>());
}
